var _path, _path2, _path3, _mask, _g, _circle, _path4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLockedLogo = function SvgLockedLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 136,
    viewBox: "0 0 148 136",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.073 59.3803C138.61 46.2174 118.703 38.3238 101.842 43.5475C82.5953 49.51 88.9766 74.0142 71.495 78.9693C62.0517 81.6459 48.0917 71.6474 38.5509 70.1141C20.9698 67.2889 5.05408 77.2187 1.13497 90.9695C-2.86333 104.998 3.54951 123.735 22.8051 127.543C45.7422 132.079 57.69 115.574 76.9317 110.835C96.6775 105.971 118.633 117.457 134.979 103.482C147.056 93.1579 151.472 72.4142 145.073 59.3803Z",
    fill: "#FDEDE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2946 26.2591C24.0905 23.7678 25.4868 21.4207 27.7734 20.4111C57.2197 7.40922 90.7802 7.40922 120.227 20.4111C122.513 21.4207 123.909 23.7678 123.705 26.2591L117.836 97.918C117.436 102.803 114.818 107.236 110.734 109.945L76.2111 132.845C74.871 133.734 73.1289 133.734 71.7889 132.845L37.2661 109.945C33.1815 107.236 30.5641 102.803 30.164 97.918L24.2946 26.2591Z",
    fill: "#CAB3FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2736 26.1871C31.7576 27.2993 30.2216 29.8825 30.4459 32.6242L35.3166 92.1595C35.7536 97.5001 38.6132 102.346 43.0769 105.311L70.9573 123.826C72.801 125.051 75.199 125.051 77.0428 123.826L104.923 105.311C109.387 102.346 112.246 97.5001 112.683 92.1595L117.554 32.6242C117.778 29.8825 116.242 27.2993 113.726 26.1871C88.4232 15.0017 59.5769 15.0017 34.2736 26.1871Z",
    fill: "white",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 19,
    width: 86,
    height: 105
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9342 32.3388C33.8314 31.0821 34.5355 29.8981 35.6887 29.3883C60.0906 18.6013 87.9094 18.6013 112.311 29.3883C113.465 29.8981 114.169 31.0821 114.066 32.3388L109.195 91.8741C108.846 96.1466 106.558 100.023 102.987 102.395L75.1065 120.911C74.436 121.356 73.564 121.356 72.8936 120.911L45.0132 102.395C41.4422 100.023 39.1545 96.1465 38.805 91.8741L33.9342 32.3388Z",
    fill: "#A6CBFF",
    stroke: "#EE6F44",
    strokeWidth: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 88.5082C90.4705 88.5082 104.37 91.1845 104.37 101.51C104.37 111.84 90.3793 145.126 74 145.126C57.5333 145.126 43.6301 111.745 43.6301 101.419C43.6301 91.0896 57.6207 88.5082 74 88.5082ZM74 38.4967C85.1576 38.4967 94.0973 47.4332 94.0973 58.5828C94.0973 69.7325 85.1576 78.6728 74 78.6728C62.8463 78.6728 53.9028 69.7325 53.9028 58.5828C53.9028 47.4332 62.8463 38.4967 74 38.4967Z",
    fill: "#4E0BD7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.214,
    cy: 106.936,
    r: 26.4538,
    fill: "#E01A00",
    stroke: "white",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.194 91.6316C115.277 91.6316 118.563 94.8451 118.563 98.8124V100.853C120.855 101.568 122.525 103.643 122.525 106.121V112.691C122.525 115.759 119.982 118.247 116.846 118.247H105.583C102.446 118.247 99.9024 115.759 99.9024 112.691V106.121C99.9024 103.643 101.574 101.568 103.864 100.853V98.8124C103.878 94.8451 107.164 91.6316 111.194 91.6316ZM111.207 106.781C110.558 106.781 110.031 107.297 110.031 107.932V110.868C110.031 111.516 110.558 112.031 111.207 112.031C111.87 112.031 112.397 111.516 112.397 110.868V107.932C112.397 107.297 111.87 106.781 111.207 106.781ZM111.221 93.9458C108.476 93.9458 106.244 96.1146 106.231 98.786V100.566H116.197V98.8124C116.197 96.1279 113.966 93.9458 111.221 93.9458Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.6359,
    y1: 21.815,
    x2: 112.925,
    y2: 108.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E42F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E42F5",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockedLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locked_logo.6a61e5b0.svg";
export { ForwardRef as ReactComponent };